// @core/api/endpoints/workflow/get_pipeline_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelinePolicyResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get entity pipeline policy
 * Returns the pipeline policy directly attached to the specified entity (if any). Does NOT resolve inheritance — use ResolvePipelineContext for that.
 */
export async function GetPipelinePolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<PipelinePolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/pipelines/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<PipelinePolicyResponse>(requestPath, { ...requestOptions });
}
